import { createSlice, createAction } from '@reduxjs/toolkit';

const initialState = {
  modules: [],
};

export const apis = createSlice({
  name: 'apis',
  initialState,
  reducers: {
    getInitDataSuccess: (state, action) => {
      state.modules = action.payload.modules;
    },
    getInitDataFailure: (state) => {
      state.modules = [];
    },
  },
});

const actionsTmp: any = { ...apis.actions };
actionsTmp.getInitData = createAction('apis/getInitData');

export const actions = { ...actionsTmp };

export const userSelector = (state: any) => state;

export default apis.reducer;
